varying vec3 vPos;
uniform float uTime;
uniform float uScroll;
uniform float uEntrance;
void main()
{
  float distanceToCenter = distance(gl_PointCoord, vec2(0.5));
  float strength = 0.05 / distanceToCenter - 0.1;

  vec3 color = vec3(1.0, 0.5, 0.0);

  if (uScroll < uRange) {
    color = vec3(1.0);
  } else if (uScroll < uRange * 2.0) {
    color = vec3(1.0);
  } else if (uScroll < uRange * 3.0) {
    color = vec3(1.0);
  } else if (uScroll < uRange * 4.0) {
    color = vec3(1.0);
  } else {
    color = vec3(0.753, 0.604, 1.0);
  }

  gl_FragColor = vec4(color, strength * length(vPos) * uEntrance);
}
